export function countCommonCharacters(...strings: Array<string>): number {
  const [sample, ...rest] = strings;
  for (let i = 0; ; i++) {
    if (i >= sample.length || rest.some(r => r[i] !== sample[i])) return i;
  }
}

const ENTITY_MAPPING = {
  '&amp;': '&',
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&apos;': '\'',
};

const ENTITY_EXP = new RegExp(Object.keys(ENTITY_MAPPING).join('|'), 'g');

export function decodeHtmlEntities(text: string): string {
  return text.replace(ENTITY_EXP, m => ENTITY_MAPPING[m as keyof typeof ENTITY_MAPPING]);
}